import React from "react";
import { compose } from "redux";
import { findDOMNode } from "react-dom";
import { DropTarget } from "react-dnd";
import classNames from "classnames";

import connectActions from "fantastic/lib/connectActions";
import connectProps from "fantastic/lib/connectProps";
import directSettings from "fantastic/lib/directSettings";

const spec = isContainer => ({
  canDrop(props, monitor) {
    if (props.meta) {
      const item = monitor.getItem();
      const settings = directSettings();

      if (item.meta && item.meta.kind === "table" && props.meta.forbidForTable)
        return false;
    }

    return true;
  },

  hover(props, monitor, component) {
    if (!monitor.canDrop()) return;

    if (
      isContainer &&
      props.meta &&
      props.meta.type &&
      (props.meta.type === "COLUMN" || props.meta.type === "CELL") &&
      props.items &&
      props.items.length > 0
    )
      return;

    const node = findDOMNode(component);

    const hoverBoundingRect = node.getBoundingClientRect();
    const hoverMiddleY = hoverBoundingRect.height / 2 + hoverBoundingRect.top;
    const clientOffset = monitor.getClientOffset();
    let place = clientOffset.y < hoverMiddleY ? "up" : "down";

    if (
      window.target &&
      window.target.id === props.id &&
      window.target.place === place &&
      window.target.type === props.type
    )
      return;

    [...document.querySelectorAll(".placeholder")].map(elm => elm.remove());

    const placeholder = document.createElement("div");
    placeholder.classList.add("placeholder");

    window.target = { id: props.id, place, type: props.type };

    if (place === "down") {
      node.appendChild(placeholder);
    } else {
      node.insertBefore(placeholder, node.childNodes[0]);
    }
  },
  drop(props, monitor, component) {
    if (monitor.didDrop()) {
      return;
    }

    [...document.querySelectorAll(".placeholder")].map(elm => elm.remove());

    const node = findDOMNode(component);

    const hoverBoundingRect = node.getBoundingClientRect();
    const hoverMiddleY = hoverBoundingRect.height / 2 + hoverBoundingRect.top;
    const clientOffset = monitor.getClientOffset();
    let place = clientOffset.y < hoverMiddleY ? "up" : "down";

    const div = document.createElement("div");
    div.classList.add("placeholder");

    if (place === "up") {
      node.insertBefore(div, node.childNodes[0]);
    } else {
      node.appendChild(div);
    }

    const item = monitor.getItem();

    return { moved: true, item };
  }
});

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget()
});

export default (type, isContainer = null) => Component => {
  class DroppableComponent extends React.Component {
    render() {
      const { connectDropTarget, id } = this.props;
      const divClasses = Array.isArray(type)
        ? `ftc-drop--${type.join("-")}`
        : `ftc-drop--${type}`;

      return connectDropTarget(
        <div data-drop-target className={divClasses}>
          <Component {...this.props} />
        </div>
      );
    }
  }

  return DropTarget(type, spec(isContainer), collect)(DroppableComponent);
};
